import { observable, computed } from 'mobx';
import { loadStripe } from '@stripe/stripe-js';

// import { loadExternalScript } from 'apps/utils';

export class StripeStore {
  @observable _stripe = null;

  constructor() {
    if (!STRIPE_API_KEY) return;
    this.loadStripe();
  }

  loadStripe = () => {
    // should check status of promise and only initiate a new one if this one has failed
    this.stripePromise = loadStripe(STRIPE_API_KEY);
    this.stripePromise.then(stripe => {
      this._stripe = stripe;
    });
  };

  @computed get stripe() {
    if (!this._stripe) this.loadStripe();
    return this._stripe;
  }
}

export const stripeStore = new StripeStore();
